<template>
  <tr
      class="mdm-edit-row"
      style="background-color: #FFF9DF;font-size: 12px;"
  >
    <th
        class="mdm-form-cell mdm-form-cell-spacer action-col"
        :class="{ 'mdm-sticky-block-edge': fr.stickyBlockRightEdgeIsAction }"
        style="background-color:rgb(251, 235, 196)"
    ></th>
    <th
        v-for="(col, index) in columns"
        :key="index"
        class="mdm-form-cell"
        :class="{
          'mdm-form-cell--select': fr.isMdmInlineSelectColumn(col, index),
          'mdm-form-cell--tel': columnsInfo[index]['fieldValidationType'] === 'phoneNumber',
          'mdm-form-cell--date': columnsInfo[index]['fieldValidationType'] === 'date',
          'sno-col': fr.mdmIsStickyAnchorDisplayName(col),
          'sticky-follow-col': cellLayout.flags[index],
          'mdm-sticky-block-edge': fr.isStickyBlockRightEdgeColumn(index),
        }"
        :style="cellLayout.styles[index]"
        style="background-color: rgb(251, 235, 196)"
    >
      <!-- <label>{{ col }}</label> -->
      <!-- <span v-if="columnsInfo[index]['fieldIsNullable']==='N'" class="text-danger">*</span> -->
      <input
          v-if="isEditable(index) && !disabledFieldUsesMultiline(index)"
          type="text"
          class="form-control mdm-disabled-text"
          :value="displayDisabledValue(index)"
          disabled
      >
      <textarea
          v-else-if="isEditable(index) && disabledFieldUsesMultiline(index)"
          class="form-control mdm-disabled-text mdm-edit-multiline-field"
          rows="2"
          :value="displayDisabledValue(index)"
          disabled
      ></textarea>
      <input
          v-else-if="genericPlainField(index) && !plainTextUsesMultiline(index)"
          type="text"
          :value="transformedDisplayValue(index)"
          class="form-control"
          :class="{'mdm-required-input': isMandatory(index)}"
          :disabled="columnsInfo[index]['fieldIsEditable']"
          @input="fr.updateValue($event, rcolumns[index], columnsInfo[index]['requiredCase'])"
      >
      <textarea
          v-else-if="genericPlainField(index) && plainTextUsesMultiline(index)"
          :value="transformedDisplayValue(index)"
          class="form-control mdm-edit-multiline-field"
          :class="{'mdm-required-input': isMandatory(index)}"
          :disabled="columnsInfo[index]['fieldIsEditable']"
          rows="1"
          @input="onWrappedTextInput($event, rcolumns[index], columnsInfo[index]['requiredCase'])"
      ></textarea>

      <input
          v-else-if="columnsInfo[index]['fieldValidationType'] === 'textarea' && !schemaTextareaUsesMultiline(index)"
          type="text"
          :value="transformedDisplayValue(index)"
          class="form-control"
          :class="{'mdm-required-input': isMandatory(index)}"
          :disabled="columnsInfo[index]['fieldIsEditable']"
          @input="fr.updateValue($event, rcolumns[index], columnsInfo[index]['requiredCase'])"
      >
      <textarea
          v-else-if="columnsInfo[index]['fieldValidationType'] === 'textarea' && schemaTextareaUsesMultiline(index)"
          :value="displayRowValue(index)"
          class="form-control auto-expand-textarea mdm-edit-multiline-field"
          :class="{'mdm-required-input': isMandatory(index)}"
          :disabled="columnsInfo[index]['fieldIsEditable']"
          @input="onWrappedTextInput($event, rcolumns[index], columnsInfo[index]['requiredCase'])"
      ></textarea>

      <div
          v-else-if="columnsInfo[index]['fieldValidationType'] === 'date'"
          class="date-picker-container"
          :class="{'mdm-required-input': isMandatory(index)}"
      >
        <date-picker
            :value="displayRowValue(index)"
            value-type="DD/MM/YYYY"
            format="DD/MM/YYYY"
            type="date"
            placeholder="Select date"
            :clearable="false"
            :disabled="columnsInfo[index]['fieldIsEditable']"
            @input="onDateInput($event, rcolumns[index])"
        ></date-picker>
      </div>

      <ValidationProvider
          v-else-if="columnsInfo[index]['fieldValidationType']==='email'"
          :vid="rcolumns[index]"
          :name="col"
          :rules="fr.veeRulesEmail(columnsInfo[index])"
          v-slot="{ errors, validate }"
      >
        <input
            v-if="!emailFieldUsesMultiline(index)"
            :value="displayRowValue(index)"
            :type="columnsInfo[index]['fieldValidationType']"
            class="form-control"
            :class="{'mdm-required-input': isMandatory(index)}"
            :disabled="columnsInfo[index]['fieldIsEditable']"
            @change="fr.handleValidateFunc(columnsInfo[index]['fieldValidationType'], rowInsert[rcolumns[index]])"
            @input="(e) => { fr.updateValue(e, rcolumns[index], columnsInfo[index]['requiredCase']); validate(e); }"
        >
        <textarea
            v-else
            :value="displayRowValue(index)"
            class="form-control mdm-edit-multiline-field"
            :class="{'mdm-required-input': isMandatory(index)}"
            :disabled="columnsInfo[index]['fieldIsEditable']"
            rows="1"
            @change="fr.handleValidateFunc(columnsInfo[index]['fieldValidationType'], rowInsert[rcolumns[index]])"
            @input="(e) => { onWrappedTextInput(e, rcolumns[index], columnsInfo[index]['requiredCase']); validate(e); }"
        ></textarea>
        <span v-if="errors.length" class="help is-danger mdm-vee-error">
          {{ errors[0] }}
        </span>
      </ValidationProvider>

      <ValidationProvider
          v-else-if="columnsInfo[index]['fieldValidationType'] === 'number'"
          :vid="rcolumns[index]"
          :name="col"
          :rules="fr.veeRulesNumeric(columnsInfo[index])"
          v-slot="{ errors, validate }"
      >
        <input
            type="text"
            class="form-control"
            :class="{'mdm-required-input': isMandatory(index)}"
            :value="fr.numberInputDisplay(displayRowValue(index))"
            :disabled="columnsInfo[index]['fieldIsEditable']"
            @input="(e) => { fr.handleNumberInput(e, rcolumns[index], rowInsert); validate(e); }"
        >
        <span v-if="errors.length" class="help is-danger mdm-vee-error">
          {{ errors[0] }}
        </span>
      </ValidationProvider>

      <ValidationProvider
          v-else-if="columnsInfo[index]['fieldValidationType'] === 'phoneNumber'"
          :vid="rcolumns[index]"
          :name="col"
          :rules="fr.veeRulesPhone(columnsInfo[index])"
          v-slot="{ errors, validate }"
      >
        <input
            type="tel"
            class="form-control"
            :class="{'mdm-required-input': isMandatory(index)}"
            :value="displayRowValue(index)"
            placeholder="Enter 10-digit phone number"
            maxlength="10"
            :disabled="columnsInfo[index]['fieldIsEditable']"
            @input="(e) => { fr.handleIndianPhoneNumberInput(e, rcolumns[index], rowInsert); validate(e); }"
        >
        <span v-if="errors.length" class="help is-danger mdm-vee-error">
          {{ errors[0] }}
        </span>
      </ValidationProvider>

      <div
          v-else-if="(col!=='Mfg. Name' && col!=='Brand Name') && fr.isMdmListboxField(columnsInfo[index])"
          class="mdm-inline-select"
          :class="{'mdm-required-input': isMandatory(index)}"
      >
        <v-select
            :append-to-body="true"
            :options="selectOptions(index)"
            :value="displaySelectValue(index)"
            :disabled="columnsInfo[index]['fieldIsEditable']"
            @input="fr.onRowSelectInput(rowInsert, rcolumns[index], $event)"
        ></v-select>
      </div>
    </th>
  </tr>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import {ValidationProvider} from 'vee-validate'

export default {
  name: 'MdmFormReportEditRow',
  components: {ValidationProvider, DatePicker},
  inject: ['mdmFormReport'],
  data() {
    return {
      initialRowValues: {},
    }
  },
  props: {
    rowInsert: {
      type: Object,
      required: true,
    },
    columns: {
      type: Array,
      required: true,
    },
    rcolumns: {
      type: Array,
      required: true,
    },
    columnsInfo: {
      type: Array,
      required: true,
    },
    cellLayout: {
      type: Object,
      required: true,
      validator(v) {
        return v && Array.isArray(v.flags) && Array.isArray(v.styles)
      },
    },
  },
  computed: {
    fr() {
      return this.mdmFormReport
    },
  },
  watch: {
    rowInsert: {
      handler() {
        this.captureInitialRowValues()
      },
      immediate: true,
    },
  },
  methods: {
    sameValue(a, b) {
      if (Array.isArray(a) || Array.isArray(b)) {
        return JSON.stringify(a) === JSON.stringify(b)
      }
      return a === b
    },
    /** Plain text/email fields switch to textarea only when displayed length exceeds this threshold. */
    textLengthUsesMultiline(value) {
      if (value === null || value === undefined) return false
      if (Array.isArray(value)) {
        return value.join(', ').length > 5
      }
      return String(value).length > 5
    },
    transformedValueUsesMultiline(index) {
      const v = this.transformedDisplayValue(index)
      return this.textLengthUsesMultiline(v)
    },
    disabledFieldUsesMultiline(index) {
      return this.textLengthUsesMultiline(this.displayDisabledValue(index))
    },
    genericPlainField(index) {
      const c = this.columnsInfo[index]
      if (!c) return false
      return !this.fr.isMdmListboxField(c)
        && c.fieldValidationType !== 'date'
        && c.fieldValidationType !== 'email'
        && c.fieldValidationType !== 'number'
        && c.fieldValidationType !== 'phoneNumber'
        && c.fieldValidationType !== 'textarea'
    },
    plainTextUsesMultiline(index) {
      return this.genericPlainField(index) && this.transformedValueUsesMultiline(index)
    },
    schemaTextareaUsesMultiline(index) {
      return (
        this.columnsInfo[index]['fieldValidationType'] === 'textarea'
        && this.transformedValueUsesMultiline(index)
      )
    },
    emailFieldUsesMultiline(index) {
      return this.textLengthUsesMultiline(this.displayRowValue(index))
    },
    onWrappedTextInput(event, column, requiredCase) {
      this.fr.updateValue(event, column, requiredCase)
      this.fr.autoExpand(event)
    },
    /** Size textareas after initial row data so wrapped content is visible without typing. */
    expandEditRowTextareas() {
      this.$nextTick(() => {
        const root = this.$el
        if (!root || !root.querySelectorAll) {
          return
        }
        root.querySelectorAll('textarea.mdm-edit-multiline-field').forEach((el) => {
          this.fr.autoExpand({ target: el })
        })
      })
    },
    captureInitialRowValues() {
      const snapshot = {}
      this.rcolumns.forEach((key) => {
        if (!key) return
        const value = this.rowInsert[key]
        snapshot[key] = Array.isArray(value) ? value.slice() : value
      })
      this.initialRowValues = snapshot
    },
    isMandatory(index) {
      return this.columnsInfo[index] && this.columnsInfo[index].fieldIsNullable === 'N'
    },
    isEditable(index) {
      return !!(this.columnsInfo[index] && this.columnsInfo[index].fieldIsEditable)
    },
    shouldShowPreviousValue(index) {
      const columnInfo = this.columnsInfo[index]
      if (!columnInfo) return true
      const previousValue = columnInfo.previousValue === true || columnInfo.previousValue === 'true'
      const isDisabledField = !!columnInfo.fieldIsEditable
      return previousValue || isDisabledField
    },
    displayRowValue(index) {
      const key = this.rcolumns[index]
      if (!key) return ''
      if (
        !this.shouldShowPreviousValue(index)
        && this.sameValue(this.rowInsert[key], this.initialRowValues[key])
      ) {
        return ''
      }
      return this.rowInsert[key]
    },
    transformedDisplayValue(index) {
      return this.fr.transformValue(
        this.displayRowValue(index),
        this.columnsInfo[index]['requiredCase'],
      )
    },
    displaySelectValue(index) {
      const value = this.displayRowValue(index)
      return value === '' ? null : value
    },
    selectOptions(index) {
      const key = this.rcolumns[index]
      if (!key) return []
      if (this.shouldShowPreviousValue(index)) {
        return this.fr.getOptionsForRowSelect(this.rowInsert, key)
      }

      // previousValue=false => treat like insert row for select options.
      // Keep user-changed selections, but clear untouched previous values.
      const rowLikeNew = { ...this.rowInsert }
      this.rcolumns.forEach((colKey, colIndex) => {
        if (!colKey) return
        const colInfo = this.columnsInfo[colIndex]
        if (!colInfo || !this.fr.isMdmListboxField(colInfo)) return
        const previousValue = colInfo.previousValue === true || colInfo.previousValue === 'true'
        if (previousValue) return
        if (this.sameValue(rowLikeNew[colKey], this.initialRowValues[colKey])) {
          rowLikeNew[colKey] = ''
        }
      })

      return this.fr.getOptionsForRowSelect(rowLikeNew, key)
    },
    onDateInput(value, column) {
      this.fr.date(value, column, this.rowInsert)
    },
    displayDisabledValue(index) {
      const value = this.displayRowValue(index)
      if (Array.isArray(value)) {
        return value.join(', ')
      }
      if (value === null || value === undefined) {
        return ''
      }
      return String(value)
    },
  },
  mounted() {
    this.expandEditRowTextareas()
  },
}
</script>

<style scoped>
/* Multi-line editable fields: plain <input> cannot wrap; textarea grows with content (fr.autoExpand). */
.mdm-edit-row .mdm-edit-multiline-field {
  width: 100%;
  box-sizing: border-box;
  min-height: calc(1.5em + 0.75rem + 2px);
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
  white-space: pre-wrap;
  resize: vertical;
}

.mdm-required-input.form-control {
  border-color: #f0b7bf !important;
  background: linear-gradient(180deg, #fffdfd 0%, #fff8f9 100%);
  box-shadow: inset 0 0 0 1px rgba(220, 53, 69, 0.08);
  transition: border-color .18s ease, box-shadow .18s ease, background-color .18s ease;
  border-radius: 0.25rem;
}

.mdm-required-input.form-control:hover {
  border-color: #e8a5af !important;
}

.mdm-required-input.form-control:focus {
  border-color: #d77a88 !important;
  box-shadow: 0 0 0 0.14rem rgba(215, 122, 136, 0.22), inset 0 0 0 1px rgba(215, 122, 136, 0.12) !important;
  background: #fff;
}

.mdm-required-input.form-control::placeholder {
  color: #b7848c;
  opacity: 0.9;
}

.mdm-required-input ::v-deep .mx-input,
.mdm-required-input ::v-deep .vs__dropdown-toggle {
  border-color: #f0b7bf !important;
  background: linear-gradient(180deg, #fffdfd 0%, #fff8f9 100%);
  box-shadow: inset 0 0 0 1px rgba(220, 53, 69, 0.08);
  transition: border-color .18s ease, box-shadow .18s ease, background-color .18s ease;
  border-radius: 0.25rem;
}

.mdm-required-input ::v-deep .mx-input:hover,
.mdm-required-input ::v-deep .vs__dropdown-toggle:hover {
  border-color: #e8a5af !important;
}

.mdm-required-input ::v-deep .mx-input:focus,
.mdm-required-input ::v-deep .vs__dropdown-toggle:focus,
.mdm-required-input ::v-deep .vs--open .vs__dropdown-toggle {
  border-color: #d77a88 !important;
  box-shadow: 0 0 0 0.14rem rgba(215, 122, 136, 0.22), inset 0 0 0 1px rgba(215, 122, 136, 0.12) !important;
  background: #fff;
}

/* Stronger disabled state for edit row fields */
.mdm-edit-row .form-control:disabled,
.mdm-edit-row .form-control[disabled] {
  background: #e2e6ec !important;
  border-color: #c5ced8 !important;
  color: #5f6b7a !important;
  cursor: not-allowed !important;
  box-shadow: none !important;
  opacity: 1 !important;
}

.mdm-edit-row .form-control:disabled::placeholder {
  color: #8a95a3 !important;
}

.mdm-edit-row ::v-deep .mx-input:disabled,
.mdm-edit-row ::v-deep .mx-input[disabled] {
  background: #e2e6ec !important;
  border-color: #c5ced8 !important;
  color: #5f6b7a !important;
  cursor: not-allowed !important;
  box-shadow: none !important;
  opacity: 1 !important;
}

.mdm-edit-row ::v-deep .vs--disabled .vs__dropdown-toggle,
.mdm-edit-row ::v-deep .vs--disabled .vs__search,
.mdm-edit-row ::v-deep .vs--disabled .vs__selected {
  background: #e2e6ec !important;
  border-color: #c5ced8 !important;
  color: #5f6b7a !important;
  cursor: not-allowed !important;
  opacity: 1 !important;
}

.help.is-danger.mdm-vee-error,
.help.is-danger {
  color: #dc3545 !important;
  font-size: 0.8125rem;
  font-weight: 500;
  display: block;
  margin-top: 0.25rem;
  line-height: 1.3;
}
</style>
